const FooterVariant1 = ({ theme, font, editableData = {}, renderEditable  }) => {
  const getText = (key, defaultValue) => {
    const value = editableData?.[key];
    return typeof value === 'string' ? value : value?.text || defaultValue;
  };

  return (
    <footer className="py-12 px-8"
      style={{
        backgroundColor: theme.backgroundColor,
        color: theme.textColor,
        fontFamily: font.textColor,
      }}


    >
      <div 
        className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8"
        style={{ color: theme.textColor }}
      >
        <div>
          <h3 className="text-xl font-bold mb-4" style={{ color: theme.textColor }}>{renderEditable ? renderEditable("company", getText("company", "Company")) : getText("company", "Company")}</h3>
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("about", getText("about", "About")) : getText("about", "About")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("careers", getText("careers", "Careers")) : getText("careers", "Careers")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("contact", getText("contact", "Contact")) : getText("contact", "Contact")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("blog", getText("blog", "Blog")) : getText("blog", "Blog")}</button>}
        </div>
        <div>
          <h3 className="text-xl font-bold mb-4" style={{ color: theme.textColor }}>{renderEditable ? renderEditable("resources", getText("resources", "Resources")) : getText("resources", "Resources")}</h3>
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("documentation", getText("documentation", "Documentation")) : getText("documentation", "Documentation")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("support", getText("support", "Support")) : getText("support", "Support")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("api_status", getText("api_status", "API Status")) : getText("api_status", "API Status")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("guides", getText("guides", "Guides")) : getText("guides", "Guides")}</button>}
        </div>
        <div>
          <h3 className="text-xl font-bold mb-4" style={{ color: theme.textColor }}>{renderEditable ? renderEditable("legal", getText("legal", "Legal")) : getText("legal", "Legal")}</h3>
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("privacy", getText("privacy", "Privacy")) : getText("privacy", "Privacy")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("terms", getText("terms", "Terms")) : getText("terms", "Terms")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("security", getText("security", "Security")) : getText("security", "Security")}</button>}
          {<button className="text-left w-full mb-1 hover:underline">{renderEditable ? renderEditable("compliance", getText("compliance", "Compliance")) : getText("compliance", "Compliance")}</button>}
        </div>
        <div>
          <h3 className="text-xl font-bold mb-4" style={{ color: theme.textColor }}>{renderEditable ? renderEditable("subscribe", getText("subscribe", "Subscribe")) : getText("subscribe", "Subscribe")}</h3>
          <p className="mb-4">{renderEditable ? renderEditable("stay_updated_with_our_newsletter", getText("stay_updated_with_our_newsletter", "Stay updated with our newsletter")) : getText("stay_updated_with_our_newsletter", "Stay updated with our newsletter")}</p>
          <div className="flex">
            <input className="px-4 py-2 w-full rounded-l focus:outline-none"
              type="email"
              placeholder="Your email"
              style={{
                backgroundColor: theme.backgroundColor,
                color: theme.textColor,
              }}
            />
            <button className="px-4 py-2 rounded-r font-medium bg-primary"
              style={{
                backgroundColor: theme.primaryColor,
                color: theme.backgroundColor,
              }}
            >{renderEditable ? renderEditable("join", getText("join", "Join")) : getText("join", "Join")}</button>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t text-center"
        style={{ borderColor: theme.textColor, color: theme.textColor }}
      >
        <p>{renderEditable ? renderEditable("2025_company_name_all_rights_reserved", getText("2025_company_name_all_rights_reserved", "© 2025 Company Name. All rights reserved.")) : getText("2025_company_name_all_rights_reserved", "© 2025 Company Name. All rights reserved.")}</p>
      </div>
    </footer>
  );
};
export default FooterVariant1;